import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ResumeApplicationModalComponent } from './resume-application-modal';

export const ResumeApplicationModalModule: string = ng
    .module('archiSmall.components.resumeApplicationModalModule', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('resumeApplicationModalComponent', ResumeApplicationModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/resume-application-modal/resume-application-modal.module.ts